import { formatCurrency } from "@/utils/currencyFormatter";

/**
 * Formats ferry prices with currency-specific rules.
 * - TRY/SAR uses currency code (TL/SAR) instead of symbol.
 * - Other currencies show symbol when available.
 * - Preserves decimals only when needed; no rounding by default.
 *
 * @param {number} price
 * @param {string} currencyCode
 * @returns {string}
 */
export const formatFerryPrice = (
  price,
  currencyCode = "TRY",
  customDecimalsControls = false,
  forceDecimals = 0,
) => {
  if (!price && price !== 0) {
    if (currencyCode === "TRY") return "0 TL";
    if (currencyCode === "SAR") return "0 SAR";
    return `0 ${currencyCode}`;
  }

  let decimals;

  if (typeof forceDecimals === "number") {
    // Dışarıdan ondalık basamak sayısı zorlanıyorsa doğrudan onu kullan
    decimals = forceDecimals;
  } else {
    let hasDecimals = price % 1 !== 0;

    // liste sayfasında TL de kusurat gozukmemesi için özel kural.
    // TL de kusurat yok ama diğer para birimlerinde kusurat gozukecek
    if (customDecimalsControls) {
      if (currencyCode === "TRY") {
        hasDecimals = false;
      } else {
        hasDecimals = true;
      }
    }

    decimals = hasDecimals ? 2 : 0;
  }

  const useCode = currencyCode === "TRY" || currencyCode === "SAR";

  return formatCurrency(price, currencyCode, {
    showSymbol: !useCode,
    showCode: useCode,
    decimals,
    round: false,
  });
};
